// Actions const
export const PRESERVE_TOKEN = "PRESERVE_TOKEN";
export const LOGIN = "LOGIN";
export const LOGIN_SUCCESS = "LOGIN_SUCCESS";
export const LOGIN_FAILURE = "LOGIN_FAILURE";
export const GET_POST_FETCH = "GET_POST_FETCH";
export const GET_POST_SUCCESS = "GET_POST_SUCCESS";
export const CREATE_POST = "CREATE_POST";
export const CREATE_POST_SUCCESS = "CREATE_POST_SUCCESS";
export const EDIT_POST = "EDIT_POST";
export const EDIT_POST_SUCCESS = "EDIT_POST_SUCCESS";
export const DELETE_POST = "DELETE_POST";
export const DELETE_POST_SUCCESS = "DELETE_POST_SUCCESS";
export const GET_POST_DETAIL_FETCH = "GET_POST_DETAIL_FETCH";
export const GET_POST_DETAIL_SUCCESS = "GET_POST_DETAIL_SUCCESS";